/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetUsersForRole = require('common/services/GetUsersForRole');

var GetAllExamInvInqLookups = require('../../common/services/GetAllExamInvInqLookups');
var GetAllInvInqLookups = require('../../common/services/GetAllInvInqLookups');
var GetInvestigationInquiry = require('../services/GetInvestigationInquiry');
var GetInvInqIdentifiers = require('../services/GetInvInqIdentifiers');
var SecInvInqGeneralEditView = require('../views/SecInvInqGeneralEditView');

module.exports = function(invInqId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(
    GetInvestigationInquiry(invInqId),
    GetInvInqIdentifiers(invInqId),
    GetAllInvInqLookups(),
    GetAllExamInvInqLookups(),
    GetUsersForRole('SC - Examiner')
  )
    .done(function(invInq, identifiers, lookups, examInvInqLookups, examiners) {
      NavUtils.navigate('#sec/investigation-inquiry/' + invInqId + '/edit');
      Scaffold.content.show(
        new SecInvInqGeneralEditView({
          model: new Backbone.Model({
            invInqId: invInqId,
            invInq: invInq,
            identifiers: identifiers,
            invInqTypes: lookups.invInqTypes,
            invInqStatuses: lookups.invInqStatuses,
            invInqCategories: lookups.invInqCategories,
            examInvInqOffices: examInvInqLookups.examInvInqOffices,
            examInvInqViolationTypes: examInvInqLookups.examInvInqViolationTypes,
            examiners: examiners
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
